import React, {useEffect, useState} from "react";
import PropTypes from 'prop-types';
import { Button } from "react-bootstrap";
import { Translate } from "../Translator";
import DatasourceBaseOauth from "../Datasources/DatasourceBaseOauth.jsx";
import { IsEmptyString } from "../GeneralFunctions"


const DatasourceServiceNow = (props) => {
  
    const [mRepainter, SetRepainter] = useState(false)

    function SetDomain(aValue)
    {
        props.IntegrationSettings.DatasourceSettings.Domain = aValue
        SetRepainter(!mRepainter)
    }

    function SetTableName(aValue)
    {
        props.IntegrationSettings.DatasourceSettings.TableName = aValue
        SetRepainter(!mRepainter)
    }

    function SetClientID(aValue)
    {
        props.IntegrationSettings.DatasourceSettings.ClientID = aValue
        SetRepainter(!mRepainter)
    }

    function SetClientSecret(aValue)
    {
        props.IntegrationSettings.DatasourceSettings.ClientSecret = aValue
        SetRepainter(!mRepainter)
    }

    let DomainUrl = (props.IntegrationSettings.DatasourceSettings.Domain ?? "").replace(/\/+$/, '') //trim trailing slashes
    if (!DomainUrl.startsWith("http://") && !DomainUrl.startsWith("https://"))
    {
        DomainUrl = "https://" + DomainUrl
    }

    const BrandingId = sessionStorage.getItem("BrandingId")

    const AuthUrl = DomainUrl +  "/oauth_auth.do" +
        "?response_type=code" +
        "&client_id=" + props.IntegrationSettings.DatasourceSettings.ClientID + 
        "&redirect_uri=https://auth.cloudcti.nl/webapi/oauth2"
    const TokenUrl = DomainUrl +  "/oauth_token.do"
    const TokenBody = "grant_type=authorization_code" + 
        "&client_id=" + props.IntegrationSettings.DatasourceSettings.ClientID + 
        "&client_secret=" + props.IntegrationSettings.DatasourceSettings.ClientSecret + 
        "&redirect_uri=https://auth.cloudcti.nl/webapi/oauth2" +
        "&code=" 
    const TokenBodyType = "application/x-www-form-urlencoded"
    const TokenCodeInBody = true
    
    return <div className="scriptitembody">
        <div className="wizardfieldname">{Translate("Domain").toUpperCase()} <span className="redtext">*</span></div>
        <div className="wizardfieldvalue"><input autoComplete="new-password" type="text" value={props.IntegrationSettings.DatasourceSettings.Domain || ""} onChange={evt => SetDomain(evt.target.value)} className="wizardinputfield"/></div>
        {props.Custom ?
            <>
                <div className="wizardfieldname">{Translate("Table name").toUpperCase()} <span className="redtext">*</span></div>
                <div className="wizardfieldvalue"><input autoComplete="new-password" type="text" value={props.IntegrationSettings.DatasourceSettings.TableName || ""} onChange={evt => SetTableName(evt.target.value)} className="wizardinputfield"/></div>
            </> 
            : <></>
        }
        <div className="wizardfieldname">{Translate("Client ID").toUpperCase()} <span className="redtext">*</span></div>
        <div className="wizardfieldvalue"><input autoComplete="new-password" type="text" value={props.IntegrationSettings.DatasourceSettings.ClientID || ""} onChange={evt => SetClientID(evt.target.value)} className="wizardinputfield"/></div>
        <div className="wizardfieldname">{Translate("Client secret").toUpperCase()} <span className="redtext">*</span></div>
        <div className="wizardfieldvalue"><input autoComplete="new-password" type="text" value={props.IntegrationSettings.DatasourceSettings.ClientSecret || ""} onChange={evt => SetClientSecret(evt.target.value)} className="wizardinputfield"/></div>

        {IsEmptyString(props.IntegrationSettings.DatasourceSettings.Domain) || (props.Custom && IsEmptyString(props.IntegrationSettings.DatasourceSettings.TableName)) || IsEmptyString(props.IntegrationSettings.DatasourceSettings.ClientID) || IsEmptyString(props.IntegrationSettings.DatasourceSettings.ClientSecret) ?
            <Button disabled variant="primary" className={BrandingId === "enreach" ? "brandbuttonprimary" : "brandbuttonkeeporiginalstyle"} type="submit">{Translate("Connect")}</Button> :
            <DatasourceBaseOauth SecurityToken={props.SecurityToken} DatasourceData={props.DatasourceData} IntegrationSettings={props.IntegrationSettings} AuthUrl={AuthUrl} TokenUrl={TokenUrl} TokenBody={TokenBody} TokenBodyType={TokenBodyType} TokenCodeInBody={TokenCodeInBody} OverrideName="ServiceNow" OnSetReady={props.OnSetReady}/>
        }
    </div>
}

DatasourceServiceNow.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    Custom: PropTypes.bool, //ServiceNow specific
    OnSetReady: PropTypes.func
}   

export default DatasourceServiceNow